var _circle, _circle2, _circle3, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconImg266(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 53,
    viewBox: "0 0 52 53",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15.5,
    cy: 37,
    r: 12.5,
    fill: "#D8FFA8"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 7.33933,
    cy: 12.4001,
    r: 1.5,
    transform: "rotate(-18 7.33933 12.4001)",
    fill: "#263238"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 14.355,
    cy: 4.86369,
    r: 1.5,
    transform: "rotate(-18 14.355 4.86369)",
    fill: "#263238"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.45473 4.50251C7.75439 4.73007 7.00219 4.3468 6.77464 3.64646C6.72 3.4783 6.6008 3.33874 6.44326 3.25847C6.28572 3.1782 6.10274 3.1638 5.93459 3.21844C5.76643 3.27307 5.62686 3.39227 5.54659 3.54981C5.46632 3.70735 5.45192 3.89033 5.50656 4.05848C5.74529 4.75113 5.36959 5.50494 4.67282 5.73133L4.65051 5.73858C4.48235 5.79322 4.34279 5.91242 4.26252 6.06996C4.18225 6.2275 4.16784 6.41047 4.22248 6.57863C4.27712 6.74679 4.39632 6.88635 4.55386 6.96662C4.7114 7.04689 4.89437 7.06129 5.06253 7.00666C5.76391 6.76516 6.52574 7.15334 6.74263 7.86271C6.79727 8.03087 6.91647 8.17043 7.07401 8.2507C7.23154 8.33097 7.41452 8.34537 7.58268 8.29073C7.75083 8.2361 7.8904 8.1169 7.97067 7.95936C8.05094 7.80182 8.06534 7.61884 8.0107 7.45069L8.00345 7.42838C7.77706 6.7316 8.16607 5.98458 8.86676 5.77059C9.03491 5.71595 9.17448 5.59675 9.25475 5.43921C9.33502 5.28167 9.34942 5.0987 9.29478 4.93054C9.24014 4.76238 9.12094 4.62282 8.9634 4.54255C8.80586 4.46228 8.62289 4.44788 8.45473 4.50251Z",
    fill: "#263238"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.9141 11.9165H15.9141C15.5162 11.9165 15.1347 12.0745 14.8534 12.3558C14.5721 12.6371 14.4141 13.0187 14.4141 13.4165V22.4165C14.4141 22.8143 14.5721 23.1959 14.8534 23.4772C15.1347 23.7585 15.5162 23.9165 15.9141 23.9165H24.9141C25.3119 23.9165 25.6934 23.7585 25.9747 23.4772C26.256 23.1959 26.4141 22.8143 26.4141 22.4165V13.4165C26.4141 13.0187 26.256 12.6371 25.9747 12.3558C25.6934 12.0745 25.3119 11.9165 24.9141 11.9165ZM24.9141 29.9165H15.9141C15.5162 29.9165 15.1347 30.0745 14.8534 30.3558C14.5721 30.6371 14.4141 31.0187 14.4141 31.4165V40.4165C14.4141 40.8143 14.5721 41.1959 14.8534 41.4772C15.1347 41.7585 15.5162 41.9165 15.9141 41.9165H24.9141C25.3119 41.9165 25.6934 41.7585 25.9747 41.4772C26.256 41.1959 26.4141 40.8143 26.4141 40.4165V31.4165C26.4141 31.0187 26.256 30.6371 25.9747 30.3558C25.6934 30.0745 25.3119 29.9165 24.9141 29.9165ZM42.9141 11.9165H33.9141C33.5162 11.9165 33.1347 12.0745 32.8534 12.3558C32.5721 12.6371 32.4141 13.0187 32.4141 13.4165V22.4165C32.4141 22.8143 32.5721 23.1959 32.8534 23.4772C33.1347 23.7585 33.5162 23.9165 33.9141 23.9165H42.9141C43.3119 23.9165 43.6934 23.7585 43.9747 23.4772C44.256 23.1959 44.4141 22.8143 44.4141 22.4165V13.4165C44.4141 13.0187 44.256 12.6371 43.9747 12.3558C43.6934 12.0745 43.3119 11.9165 42.9141 11.9165Z",
    stroke: "black",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M32.4141 29.9165H44.4141M38.4141 35.9165H44.4141M32.4141 41.9165H44.4141",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconImg266);
export default __webpack_public_path__ + "static/media/icon-img-26-6.361ce3b341b9a649821027b7e1a1f04b.svg";
export { ForwardRef as ReactComponent };